import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Context } from '../shared';


@Component({
  selector: 'igo-context-edit',
  template: require('./context-edit.component.html'),
  styles: [require('./context-edit.component.styl')]
})
export class ContextEditComponent {

  @Input()
  get context(): Context { return this._context; }
  set context(value: Context) {
    this._context = value;
  }
  private _context: Context;

  // @Output() submit: EventEmitter<ContextOptions> = new EventEmitter();
  @Output() submitForm: EventEmitter<any> = new EventEmitter();

  constructor() {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/context-edit/context-edit.component.ts